<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__grid">
        <div class="footer__brand">
          <div class="footer__logo">
            <img src="/img/icons/logo.png" alt="CandB.pro" class="footer__logo-img" />
            <span>CandB.pro</span>
          </div>
          <p class="footer__desc">Автоматический расчёт мотивационных составляющих дохода сотрудников.</p>
        </div>

        <div class="footer__col">
          <div class="footer__heading">Продукт</div>
          <router-link to="/features">Возможности</router-link>
          <router-link to="/pricing">Тарифы</router-link>
          <router-link to="/demo">Демо</router-link>
          <router-link to="/docs">Документация</router-link>
        </div>

        <div class="footer__col">
          <div class="footer__heading">Компания</div>
          <router-link to="/contacts">Контакты</router-link>
          <router-link to="/policy">Политика конфиденциальности</router-link>
          <router-link to="/terms">Условия использования</router-link>
        </div>

        <div class="footer__col">
          <div class="footer__heading">Связаться</div>
          <a href="tel:+79939037308">+7 993 903-73-08</a>
          <a href="mailto:info@candb.pro">info@candb.pro</a>
          <a href="https://t.me/candbpro" target="_blank" rel="noopener" class="footer__tg">
            <ui-icon name="send" :size="16" />
            <span>Канал в Telegram</span>
          </a>
          <!-- Адрес сообщества пока числовой: красивый screen_name ставится только
               вручную в настройках — через API он «only available with user token»,
               а пользовательский ключ метод groups.edit не принимает вовсе. -->
          <a href="https://vk.com/club241547523" target="_blank" rel="noopener" class="footer__tg">
            <ui-icon name="play-circle" :size="16" />
            <span>Сообщество ВКонтакте</span>
          </a>
          <router-link to="/demo" class="footer__cta">Запросить демо →</router-link>
        </div>
      </div>

      <div class="footer__bottom">
        <span>© {{ year }} CandB.pro. Все права защищены.</span>
      </div>
    </div>
  </footer>
</template>

<script>
import UiIcon from '../ui/UiIcon.vue'

export default {
  name: 'SiteFooter',
  components: { UiIcon },
  computed: {
    year() { return new Date().getFullYear() },
  },
}
</script>

<style scoped>
.footer {
  background: var(--dark);
  color: #94A3B8;
  padding: 64px 0 32px;
}
.footer__grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 48px;
}
.footer__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.125rem;
  font-weight: 700;
  color: white;
  margin-bottom: 16px;
}
.footer__logo-img {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  object-fit: contain;
}
.footer__desc { font-size: 0.9rem; line-height: 1.6; }
.footer__heading {
  font-weight: 600;
  color: white;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 16px;
}
.footer__col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer__col a {
  color: #94A3B8;
  font-size: 0.9375rem;
  text-decoration: none;
  transition: var(--transition);
}
.footer__col a:hover { color: white; }
.footer__tg {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.footer__cta { color: var(--primary) !important; font-weight: 600; }
.footer__bottom {
  border-top: 1px solid #334155;
  padding-top: 24px;
  font-size: 0.875rem;
}

@media (max-width: 900px) {
  .footer__grid { grid-template-columns: 1fr 1fr; }
  .footer__brand { grid-column: 1 / -1; }
}
@media (max-width: 600px) {
  .footer__grid { grid-template-columns: 1fr; }
}
</style>
